import { Injectable } from "@angular/core";
import { LoggingService } from "@myapp/modules/fwcore/services";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { RequestLogSystem } from "../../models/messages";

@Injectable({
  providedIn: 'root'
})

export class LogSystemServiceGrid extends BehaviorSubject<GridDataResult>  {

  public loading: boolean = true;

  constructor(protected lservice: LoggingService) {

    const emptyDataResult = {
      data: [],
      total: 0
    }

    super(emptyDataResult);
  }

  public query(req: RequestLogSystem): void {
    this.fetch(req).subscribe((x) => super.next(x));
  }

  fetch(req: RequestLogSystem): Observable<GridDataResult> {

    return this.lservice.getLogSystem$(req)
      .pipe(
        map(
          (response) =>
            <GridDataResult>{
              data: response.data,
              total: response.total,
            }
        ),
        tap(() => (this.loading = false))
      );
  }

}
